export enum EPrintViewType {
  SINGLE = 'Single',
  THREAD = 'Thread'
}
